import React from "react"
import '../../assets/css/components/loader.css'

export default function Loader() {
    return (
    <div className="loaderDiv"><div className="loader"/></div>
    );
}